// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import "./Component.css";
// import baseURL from "../ApiUrl/Apiurl";

// const ComponentTable = ({ onAdd, onEdit, onDelete }) => {
//   const [components, setComponents] = useState([]);
//   const [filteredComponents, setFilteredComponents] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchComponents = async () => {
//       try {
//         const response = await axios.get(`${baseURL}/components/`);
//         const componentsArray = Array.isArray(response.data.data) ? response.data.data : [];

//         const sortedComponents = componentsArray.sort(
//           (a, b) => new Date(b.created_at) - new Date(a.created_at)
//         );

//         setComponents(sortedComponents);
//         setFilteredComponents(sortedComponents);
//       } catch (error) {
//         console.error("Error fetching components:", error);
//       }
//     };

//     fetchComponents();
//   }, []);

//   useEffect(() => {
//     const filtered = components.filter((comp) =>
//       Object.values(comp)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase())
//     );
//     setFilteredComponents(filtered);
//     setCurrentPage(1);
//   }, [searchTerm, components]);

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);
//     const day = date.getDate().toString().padStart(2, '0');
//     const month = (date.getMonth() + 1).toString().padStart(2, '0');
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   };

//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentComponents = filteredComponents.slice(indexOfFirstEntry, indexOfLastEntry);
//   const totalPages = Math.ceil(filteredComponents.length / entriesPerPage);

//   return (
//     <div className="component-management-container">
//       <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
//         <div>
//           <h2 className="component-management-title mb-0">Component Management</h2>
//           <p className="component-management-subtitle mb-0 text-muted">Manage system components</p>
//         </div>
//         <button onClick={onAdd} className="btn btn-primary">Add New Component</button>
//       </div>

//       <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//         <div className="d-flex align-items-center gap-2">
//           Show
//           <select
//             value={entriesPerPage}
//             onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//             className="form-select form-select-sm w-auto"
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//           </select>
//           entries
//         </div>
//         <input
//           type="text"
//           placeholder="Search components..."
//           className="form-control w-auto"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       <div className="table-responsive mb-4">
//         <table className="table">
//           <thead className="product-table-header">
//             <tr>
//               <th>S.No</th>
//               <th>Component ID</th>
//               <th>Name</th>
//               <th>Description</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentComponents.length > 0 ? (
//               currentComponents.map((component, index) => (
//                 <tr key={index}>
//                   <td>{indexOfFirstEntry + index + 1}</td>
//                   <td>{component.component_id}</td>
//                   <td>{component.component_name}</td>
//                   <td>{component.component_description}</td>
//                  <td>
//   <div className="action-icons">
//     <FaEye
//       title="View"
//       onClick={() => navigate(`/components/view/${component.component_id}`)}
//       className="action-icon view-icon"
//     />
//     <FaEdit
//       title="Edit"
//       onClick={() => onEdit(component.component_id)}
//       className="action-icon edit-icon"
//     />
//     <FaTrash
//       title="Delete"
//       onClick={async () => {
//         try {
//           await onDelete(component.component_id);
//           setComponents(prev =>
//             prev.filter(c => c.component_id !== component.component_id)
//           );
//         } catch (error) {
//           console.error("Failed to delete component:", error);
//         }
//       }}
//       className="action-icon delete-icon"
//     />
//   </div>
// </td>

//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="5" className="text-center">No components found.</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       <div className="pagination-controls d-flex justify-content-center mt-3">
//         <button
//           className="btn btn-outline-primary me-2"
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((prev) => prev - 1)}
//         >
//           Previous
//         </button>
//         <span className="align-self-center mx-2">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           className="btn btn-outline-primary ms-2"
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((prev) => prev + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ComponentTable;







// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import "./Component.css";
// import baseURL from "../ApiUrl/Apiurl";
// import Swal from 'sweetalert2';

// const ComponentTable = ({ onAdd, onEdit }) => {
//   const [components, setComponents] = useState([]);
//   const [filteredComponents, setFilteredComponents] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   const fetchComponents = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await axios.get(`${baseURL}/components/`);
//       const componentsArray = Array.isArray(response.data.data) ? response.data.data : [];

//       const sortedComponents = componentsArray.sort(
//         (a, b) => new Date(b.created_at) - new Date(a.created_at)
//       );

//       setComponents(sortedComponents);
//       setFilteredComponents(sortedComponents);
//     } catch (error) {
//       setError("Failed to fetch components. Please try again later.");
//       console.error("Error fetching components:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchComponents();
//   }, []);

//   const handleDelete = async (componentId) => {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: 'This component will be permanently deleted!',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       cancelButtonColor: '#3085d6',
//       confirmButtonText: 'Yes, delete it!'
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await axios.delete(`${baseURL}/components/${componentId}/`);
//           Swal.fire({
//             icon: 'success',
//             title: 'Deleted!',
//             text: 'Component deleted successfully!',
//             confirmButtonColor: '#3085d6',
//           });
//           // Refresh the component list after successful deletion
//           fetchComponents();
//         } catch (error) {
//           console.error(error);
//           Swal.fire({
//             icon: 'error',
//             title: 'Failed!',
//             text: 'Could not delete the component. Please try again.',
//             confirmButtonColor: '#d33',
//           });
//         }
//       }
//     });
//   };

//   useEffect(() => {
//     const filtered = components.filter((comp) =>
//       Object.values(comp)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase())
//     );
//     setFilteredComponents(filtered);
//     setCurrentPage(1);
//   }, [searchTerm, components]);

//  const formatDateTime = (dateString) => {
//   if (!dateString) return '-';
//   const date = new Date(dateString);

//   return date.toLocaleString('en-IN', {
//     day: '2-digit',
//     month: '2-digit',
//     year: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit',
//     // second: '2-digit',
//     hour12: false,
//     timeZone: 'Asia/Kolkata'
//   });
// };


//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentComponents = filteredComponents.slice(indexOfFirstEntry, indexOfLastEntry);
//   const totalPages = Math.ceil(filteredComponents.length / entriesPerPage);

//   return (
//     <div className="component-management-container">
//       <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
//         <div>
//           <h2 className="component-management-title mb-0">Component Management</h2>
//           <p className="component-management-subtitle mb-0 text-muted">Manage system components</p>
//         </div>
//         <button onClick={onAdd} className="btn btn-primary">Add New Component</button>
//       </div>

//       <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//         <div className="d-flex align-items-center gap-2">
//           Show
//           <select
//             value={entriesPerPage}
//             onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//             className="form-select form-select-sm w-auto"
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//           </select>
//           entries
//         </div>
//         <input
//           type="text"
//           placeholder="Search components..."
//           className="form-control w-auto"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       {loading ? (
//         <div className="text-center my-3">
//           <div className="spinner-border text-primary"></div>
//           <p>Loading components...</p>
//         </div>
//       ) : error ? (
//         <div className="alert alert-danger">{error}</div>
//       ) : (
//         <>
//           <div className="table-responsive mb-4">
//             <table className="table">
//               <thead className="product-table-header">
//                 <tr>
//                   <th>S.No</th>
//                   <th>Component ID</th>
//                   <th>Name</th>
//                   <th>Description</th>
//                   <th>Created At</th>
//                   <th>Updated At</th>
//                   <th>Created By</th>
//                   <th>Updated By</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentComponents.length > 0 ? (
//                   currentComponents.map((component, index) => (
//                     <tr key={index}>
//                       <td>{indexOfFirstEntry + index + 1}</td>
//                       <td>{component.component_id}</td>
//                       <td>{component.component_name}</td>
//                       <td>{component.component_description}</td>
//                       <td>{formatDateTime(component.created_at)}</td>
//                       <td>{formatDateTime(component.updated_at)}</td>
//                       <td>{component.created_by || '-'}</td>
//                       <td>{component.updated_by || '-'}</td>
//                       <td>
//                         <div className="action-icons">
//                           {/* <FaEye
//                             title="View"
//                             onClick={() => navigate(`/components/view/${component.component_id}`)}
//                             className="action-icon view-icon"
//                           /> */}
//                           <FaEdit
//                             title="Edit"
//                             onClick={() => onEdit(component.component_id)}
//                             className="action-icon edit-icon"
//                           />
//                           <FaTrash
//                             title="Delete"
//                             onClick={() => handleDelete(component.component_id)}
//                             className="action-icon delete-icon"
//                           />
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="9" className="text-center">No components found.</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           <div className="pagination-controls d-flex justify-content-center mt-3">
//             <button
//               className="btn btn-outline-primary me-2"
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage((prev) => prev - 1)}
//             >
//               Previous
//             </button>
//             <span className="align-self-center mx-2">
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               className="btn btn-outline-primary ms-2"
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage((prev) => prev + 1)}
//             >
//               Next
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default ComponentTable;


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import "./Component.css";
// import baseURL from "../ApiUrl/Apiurl";
// import Swal from 'sweetalert2';

// const ComponentTable = ({ onAdd, onEdit }) => {
//   const [components, setComponents] = useState([]);
//   const [filteredComponents, setFilteredComponents] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [usersLoading, setUsersLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   // Fetch users data
//   const fetchUsers = async () => {
//     setUsersLoading(true);
//     try {
//       const response = await axios.get(`${baseURL}/users/`);
//       const usersArray = Array.isArray(response.data) ? response.data : [];
//       setUsers(usersArray);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     } finally {
//       setUsersLoading(false);
//     }
//   };

//   // Fetch components data
//   const fetchComponents = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await axios.get(`${baseURL}/components/`);
//       const componentsArray = Array.isArray(response.data.data) ? response.data.data : [];

//       const sortedComponents = componentsArray.sort(
//         (a, b) => new Date(b.created_at) - new Date(a.created_at)
//       );

//       setComponents(sortedComponents);
//       setFilteredComponents(sortedComponents);
//     } catch (error) {
//       setError("Failed to fetch components. Please try again later.");
//       console.error("Error fetching components:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//     fetchComponents();
//   }, []);

//   // Function to get username from user_id
//   const getUsername = (userId) => {
//     if (!userId || users.length === 0) return userId; // Return user_id if no users data
    
//     const user = users.find(user => user.user_id === userId);
//     return user ? user.username : userId; // Return username if found, otherwise return user_id
//   };

//   const handleDelete = async (componentId) => {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: 'This component will be permanently deleted!',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       cancelButtonColor: '#3085d6',
//       confirmButtonText: 'Yes, delete it!'
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await axios.delete(`${baseURL}/components/${componentId}/`);
//           Swal.fire({
//             icon: 'success',
//             title: 'Deleted!',
//             text: 'Component deleted successfully!',
//             confirmButtonColor: '#3085d6',
//           });
//           // Refresh the component list after successful deletion
//           fetchComponents();
//         } catch (error) {
//           console.error(error);
//           Swal.fire({
//             icon: 'error',
//             title: 'Failed!',
//             text: 'Could not delete the component. Please try again.',
//             confirmButtonColor: '#d33',
//           });
//         }
//       }
//     });
//   };

//   useEffect(() => {
//     const filtered = components.filter((comp) =>
//       Object.values(comp)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase())
//     );
//     setFilteredComponents(filtered);
//     setCurrentPage(1);
//   }, [searchTerm, components]);

//   const formatDateTime = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);

//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: false,
//       timeZone: 'Asia/Kolkata'
//     });
//   };

//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentComponents = filteredComponents.slice(indexOfFirstEntry, indexOfLastEntry);
//   const totalPages = Math.ceil(filteredComponents.length / entriesPerPage);

//   return (
//     <div className="component-management-container">
//       <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
//         <div>
//           <h2 className="component-management-title mb-0">Component Management</h2>
//           <p className="component-management-subtitle mb-0 text-muted">Manage system components</p>
//         </div>
//         <button onClick={onAdd} className="btn btn-primary">Add New Component</button>
//       </div>

//       <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//         <div className="d-flex align-items-center gap-2">
//           Show
//           <select
//             value={entriesPerPage}
//             onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//             className="form-select form-select-sm w-auto"
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//           </select>
//           entries
//         </div>
//         <input
//           type="text"
//           placeholder="Search components..."
//           className="form-control w-auto"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       {loading || usersLoading ? (
//         <div className="text-center my-3">
//           <div className="spinner-border text-primary"></div>
//           <p>Loading {loading ? 'components' : 'users'}...</p>
//         </div>
//       ) : error ? (
//         <div className="alert alert-danger">{error}</div>
//       ) : (
//         <>
//           <div className="table-responsive mb-4">
//             <table className="table">
//               <thead className="product-table-header">
//                 <tr>
//                   <th>S.No</th>
//                   <th>Component ID</th>
//                   <th>Name</th>
//                   <th>Description</th>
//                   <th>Created At</th>
//                   <th>Updated At</th>
//                   <th>Created By</th>
//                   <th>Updated By</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentComponents.length > 0 ? (
//                   currentComponents.map((component, index) => (
//                     <tr key={index}>
//                       <td>{indexOfFirstEntry + index + 1}</td>
//                       <td>{component.component_id}</td>
//                       <td>{component.component_name}</td>
//                       <td>{component.component_description}</td>
//                       <td>{formatDateTime(component.created_at)}</td>
//                       <td>{formatDateTime(component.updated_at)}</td>
//                       <td>{getUsername(component.created_by)}</td>
//                       <td>{getUsername(component.updated_by)}</td>
//                       <td>
//                         <div className="action-icons">
//                           <FaEdit
//                             title="Edit"
//                             onClick={() => onEdit(component.component_id)}
//                             className="action-icon edit-icon"
//                           />
//                           <FaTrash
//                             title="Delete"
//                             onClick={() => handleDelete(component.component_id)}
//                             className="action-icon delete-icon"
//                           />
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="9" className="text-center">No components found.</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           <div className="pagination-controls d-flex justify-content-center mt-3">
//             <button
//               className="btn btn-outline-primary me-2"
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage((prev) => prev - 1)}
//             >
//               Previous
//             </button>
//             <span className="align-self-center mx-2">
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               className="btn btn-outline-primary ms-2"
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage((prev) => prev + 1)}
//             >
//               Next
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default ComponentTable;

//===============================================================
// After fixing filter -Global search issue 


import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Component.css";
import baseURL from "../ApiUrl/Apiurl";
import Swal from 'sweetalert2';
import { AuthContext } from "../AuthContext/AuthContext";

const ComponentTable = ({ onAdd, onEdit }) => {
  const [components, setComponents] = useState([]);
  const { userId, selectedCompany } = React.useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState(() => {
    return sessionStorage.getItem('components_searchTerm') || '';
  });
  const [entriesPerPage, setEntriesPerPage] = useState(() => {
    return Number(sessionStorage.getItem('components_entriesPerPage')) || 5;
  });
  const [currentPage, setCurrentPage] = useState(() => {
    return Number(sessionStorage.getItem('components_currentPage')) || 1;
  });
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Refs for managing requests
  const abortControllerRef = useRef(null);
  const initialLoadRef = useRef(true);

  // Session storage effects
  useEffect(() => {
    sessionStorage.setItem('components_searchTerm', searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    sessionStorage.setItem('components_entriesPerPage', entriesPerPage);
  }, [entriesPerPage]);

  useEffect(() => {
    sessionStorage.setItem('components_currentPage', currentPage);
  }, [currentPage]);

  // Fetch users data with pagination
  const fetchUsers = async () => {
    setUsersLoading(true);
    try {
      let allUsers = [];
      let page = 1;
      let hasNext = true;

      while (hasNext) {
        const response = await axios.get(`${baseURL}/users-pagination/`, {
          params: {
            page,
            page_size: 100, // Fetch in chunks
          },
        });

        const pageItems = Array.isArray(response.data.data) ? response.data.data : [];
        allUsers = allUsers.concat(pageItems);

        const pagination = response.data.pagination;
        if (pagination && pagination.has_next && pagination.next_page) {
          page = pagination.next_page;
          hasNext = true;
        } else {
          hasNext = false;
        }
      }

      setUsers(allUsers);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setUsersLoading(false);
    }
  };

  // Fetch components data with pagination
  const fetchComponents = async (page = currentPage, size = entriesPerPage, search = searchTerm, isInitial = false) => {
    // Cancel previous request if any
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    if (isInitial) {
      setLoading(true);
    } else {
      setFetching(true);
    }
    setError(null);

    abortControllerRef.current = new AbortController();

    try {
      let url = `${baseURL}/components-pagination/?page=${page}&page_size=${size}`;
      
      if (search.trim()) {
        url += `&search_query=${encodeURIComponent(search.trim())}`;
      }

      const response = await axios.get(url, {
        signal: abortControllerRef.current.signal
      });

      if (response.data.status === "success") {
        const componentsData = Array.isArray(response.data.data) ? response.data.data : [];
        setComponents(componentsData);

        // Update pagination info
        const pagination = response.data.pagination || {};
        setTotalCount(pagination.total_count || 0);
        setTotalPages(pagination.total_pages || 1);
        setHasNextPage(pagination.has_next || false);
        setCurrentPage(pagination.current_page || 1);
      } else {
        setError("Failed to fetch components");
      }
    } catch (error) {
      if (error.name === 'AbortError' || axios.isCancel(error)) {
        return;
      }
      setError("Failed to fetch components. Please try again later.");
      console.error("Error fetching components:", error);
    } finally {
      if (isInitial) {
        setLoading(false);
      } else {
        setFetching(false);
      }
      abortControllerRef.current = null;
    }
  };

  // Initial load - fetch users and components
  useEffect(() => {
    const loadInitialData = async () => {
      if (!searchTerm) {
        await Promise.all([
          fetchUsers(),
          fetchComponents(1, entriesPerPage, '', true)
        ]);
      } else {
        await Promise.all([
          fetchUsers(),
          fetchComponents(1, entriesPerPage, searchTerm, true)
        ]);
      }
      initialLoadRef.current = false;
    };

    loadInitialData();

    // Cleanup
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  // Handle search, filter, and pagination changes
  useEffect(() => {
    if (initialLoadRef.current) return;

    const debounceTimer = setTimeout(() => {
      if (userId && selectedCompany) {
        fetchComponents(1, entriesPerPage, searchTerm, false);
      }
    }, 300);

    return () => {
      clearTimeout(debounceTimer);
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [searchTerm, entriesPerPage]);

  // Handle page changes
  useEffect(() => {
    if (initialLoadRef.current) return;

    fetchComponents(currentPage, entriesPerPage, searchTerm, false);
  }, [currentPage]);

  // Function to get username from user_id
  const getUsername = (userId) => {
    if (!userId || users.length === 0) return userId;
    
    const user = users.find(user => user.user_id === userId);
    return user ? user.username : userId;
  };

  // Function to format date for display
  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);

    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Kolkata'
    });
  };

  const handleDelete = async (componentId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This component will be permanently deleted!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseURL}/components/${componentId}/`);
          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'Component deleted successfully!',
            confirmButtonColor: '#3085d6',
          });
          // Refresh current page
          fetchComponents(currentPage, entriesPerPage, searchTerm, false);
        } catch (error) {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Failed!',
            text: 'Could not delete the component. Please try again.',
            confirmButtonColor: '#d33',
          });
        }
      }
    });
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
    sessionStorage.setItem('components_currentPage', 1);
  };

  const handleEntriesPerPageChange = (value) => {
    setEntriesPerPage(value);
    setCurrentPage(1);
    sessionStorage.setItem('components_currentPage', 1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const indexOfFirstEntry = (currentPage - 1) * entriesPerPage;
  const currentComponents = components;

  return (
    <div className="component-management-container">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <div>
          <h2 className="component-management-title mb-0">Component Management</h2>
          <p className="component-management-subtitle mb-0 text-muted">Manage system components</p>
        </div>
        <button onClick={onAdd} className="btn btn-primary">Add New Component</button>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <div className="d-flex align-items-center gap-2">
          Show
          <select
            value={entriesPerPage}
            onChange={(e) => handleEntriesPerPageChange(Number(e.target.value))}
            className="form-select form-select-sm w-auto"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
          entries
        </div>
        <div className="d-flex align-items-center gap-2">
          <input
            type="text"
            placeholder="Search in all columns..."
            className="form-control"
            value={searchTerm}
            onChange={(e) => handleSearchChange(e.target.value)}
            style={{ minWidth: '300px' }}
          />
          {searchTerm && (
            <button 
              className="btn btn-sm btn-outline-secondary"
              onClick={() => handleSearchChange('')}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      {loading || usersLoading ? (
        <div className="text-center my-3">
          <div className="spinner-border text-primary"></div>
          <p>Loading {loading ? 'components' : 'users'}...</p>
        </div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <>
          {/* Results Summary */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              {searchTerm && (
                <div className="alert alert-info mb-0">
                  <strong>Search Results:</strong> Found {totalCount} component(s) matching "{searchTerm}"
                </div>
              )}
            </div>
            <div className="text-muted small">
              Showing {currentComponents.length} of {totalCount} components
            </div>
          </div>

          <div className="table-responsive mb-4">
            <table className="table">
              <thead className="product-table-header">
                <tr>
                  <th>S.No</th>
                  <th>Component ID</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Created By</th>
                  <th>Updated By</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {fetching ? (
                  <tr>
                    <td colSpan="10" className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2 mb-0 text-muted">Loading components...</p>
                    </td>
                  </tr>
                ) : currentComponents.length > 0 ? (
                  currentComponents.map((component, index) => (
                    <tr key={component.component_id || index}>
                      <td>{indexOfFirstEntry + index + 1}</td>
                      <td>{component.component_id}</td>
                      <td>{component.component_name}</td>
                      <td>{component.component_description}</td>
                      <td>{component.component_type || 'Component'}</td>
                      <td>{formatDateTime(component.created_at)}</td>
                      <td>{formatDateTime(component.updated_at)}</td>
                      <td>{getUsername(component.created_by)}</td>
                      <td>{getUsername(component.updated_by)}</td>
                      <td>
                        <div className="action-icons">
                          <FaEdit
                            title="Edit"
                            onClick={() => onEdit(component.component_id)}
                            className="action-icon edit-icon"
                          />
                          <FaTrash
                            title="Delete"
                            onClick={() => handleDelete(component.component_id)}
                            className="action-icon delete-icon"
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">
                      {searchTerm ? `No components found matching "${searchTerm}"` : 'No components found.'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination-controls d-flex justify-content-center mt-3">
              <button
                className="btn btn-outline-primary me-2"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Previous
              </button>
              
              <div className="d-flex align-items-center mx-2">
                {(() => {
                  const maxVisiblePages = 5;
                  let pageNumbers = [];

                  if (totalPages <= maxVisiblePages) {
                    for (let i = 1; i <= totalPages; i++) {
                      pageNumbers.push(i);
                    }
                  } else {
                    let startPage = Math.max(1, currentPage - 2);
                    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

                    if (endPage - startPage + 1 < maxVisiblePages) {
                      startPage = Math.max(1, endPage - maxVisiblePages + 1);
                    }

                    for (let i = startPage; i <= endPage; i++) {
                      pageNumbers.push(i);
                    }
                  }

                  return pageNumbers.map((pageNum) => (
                    <button
                      key={pageNum}
                      className={`btn mx-1 ${currentPage === pageNum ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handlePageChange(pageNum)}
                    >
                      {pageNum}
                    </button>
                  ));
                })()}
              </div>
              
              <span className="align-self-center mx-2">
                Page {currentPage} of {totalPages}
              </span>
              
              <button
                className="btn btn-outline-primary ms-2"
                disabled={!hasNextPage && currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ComponentTable;